import { render, staticRenderFns } from "./CompensationCell.vue?vue&type=template&id=990c6fd0&"
import script from "./CompensationCell.vue?vue&type=script&lang=js&"
export * from "./CompensationCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports